import React, { FC, useCallback, useState } from 'react';
import styles from '../index.module.scss';
import { ISsoConfiguration } from 'src/models/company/Security/types';
import { useTranslation } from 'react-i18next';
import SsoConfigInfoItem from './SsoConfigInfoItem';
import { Button, Modal } from 'src/common';

interface IProps {
  ssoConfig: ISsoConfiguration;
}

export const SsoConfigInfo: FC<IProps> = props => {
  const { t } = useTranslation();

  const [modalVisible, setModalVisible] = useState(false);

  const onShowModal = useCallback(() => {
    setModalVisible(true);
  }, []);

  const onHideModal = useCallback(() => {
    setModalVisible(false);
  }, []);

  const { ssoConfig } = props;
  return (
    <>
      <Button onClick={onShowModal}>{t('AdminPage.ssoConfigInfo')}</Button>
      {modalVisible && (
        <Modal
          title={t('AdminPage.ssoConfig')}
          visible={modalVisible}
          onCancel={onHideModal}
          onOk={onHideModal}
          footer={
            <>
              <Button type={'text'} onClick={onHideModal} data-action={'close'}>
                {t('Common.close')}
              </Button>
            </>
          }
        >
          <div className={styles.headerUnits}>
            <div className={styles.headerUnit}>
              <div className={styles.infoLabel}>{`${t('AdminPage.emailDomain')}:`}</div>
              <span className={styles.infoValue}>{ssoConfig.emailDomain}</span>
            </div>
            <div className={styles.headerUnit}>
              <div className={styles.infoLabel}>{`${t('AdminPage.provider')}:`}</div>
              <span className={styles.infoValue}>{ssoConfig.provider || '—'}</span>
            </div>
            <div className={styles.headerUnit}>
              <div className={styles.infoLabel}>{`${t('AdminPage.ssoConfig')}:`}</div>
              <div className={styles.infoValue}>
                <SsoConfigInfoItem value={ssoConfig.enabled} title={t('Common.enabled')} />

                <SsoConfigInfoItem value={!!ssoConfig.enforceSSO} title={t('Security.enforceSSO')} />

                <SsoConfigInfoItem
                  value={!!ssoConfig.allowNewUserCreationFromSSO}
                  title={t('Security.allowNewSSOAccounts')}
                />
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default SsoConfigInfo;
